import React, { useState } from "react";
import { portalLink } from "../utils/portal";


import {
  ArrowRight,
  ArrowDown,
  Users,
  CheckCircle2,
  Briefcase,
  BadgeCheck,
  Megaphone,
  UserCheck,
  CalendarCheck,
  GraduationCap,
  Wrench,
  Boxes,
  Compass,
  Smile,
  Building2,
  FileText,
  Search,
  X,
  Clock,
  UserCog,
  TrendingUp,
  Sparkles,
  IndianRupee,
  TrendingDown,
  Rocket,
  Wallet,
} from "lucide-react"; 

const RUST = "#c84b20";
const INK = "#141414";

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,500;1,600;1,700&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;700&display=swap");

.iht-hire-page {
  width: 100%;
  background: #F3EEE3;
  font-family: "Inter", sans-serif;
}
.iht-hire-page__topline { height: 4px; width: 100%; background: #141414; }

/* ---------- shared bits ---------- */
.iht-eyebrow { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.iht-eyebrow__line { width: 32px; height: 2px; background: #c84b20; }
.iht-eyebrow__label {
  font-family: "JetBrains Mono", monospace;
  font-size: 11px; letter-spacing: 0.16em; text-transform: uppercase; color: #c84b20;
}
.iht-eyebrow--dark .iht-eyebrow__label { color: rgba(255, 255, 255, 0.55); }
.iht-eyebrow--center { justify-content: center; }

.iht-btn {
  font-family: "JetBrains Mono", monospace;
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  padding: 10px 32px; font-size: 13px; letter-spacing: 0.02em; font-weight: 500;
  border: none; cursor: pointer; transition: all 0.2s ease;
}
.iht-btn--primary { background: #c84b20; color: #FFFFFF; }
.iht-btn--primary:hover { background: rgb(174, 80, 40); }
.iht-btn--outline { background: transparent; color: #141414; border: 2px solid rgba(0, 0, 0, 0.8); }
.iht-btn--outline:hover { background: #141414; color: #FFFFFF; }
.iht-btn--dark { background: #141414; color: #FFFFFF; padding: 10px 20px; }
.iht-btn--ghost { background: transparent; border: 1px solid rgba(0, 0, 0, 0.25); color: #141414; padding: 10px 20px; }
.iht-btn--white-outline { background: transparent; border: 1px solid rgba(255, 255, 255, 0.3); color: #FFFFFF; padding: 16px 32px; }
.iht-btn--small { padding: 16px 32px; font-size: 13px; }

/* ---------- iht-hero ---------- */
.iht-hero { position: relative; overflow: hidden; }
.iht-hero__inner { max-width: 1400px; margin: 0 auto; padding: 0 32px; position: relative; padding-top: 64px; padding-bottom: 56px; }
.iht-hero__kicker {
  font-family: "JetBrains Mono", monospace; font-size: 12px; letter-spacing: 0.16em; text-transform: uppercase;
  color: rgba(0, 0, 0, 0.5); margin-bottom: 18px;
}
.iht-hero__kicker span { color: #c84b20; }
.iht-hero__title {
  font-family: "Playfair Display", serif; font-weight: 700; letter-spacing: -0.02em; color: #141414;
  line-height: 1.08; font-size: 34px; max-width: 760px;
}
@media (min-width: 640px) 
{
.iht-hero__title 
{ font-size: 48px; } 



}

}
@media (min-width: 1024px) { .iht-hero__title { font-size: 60px; } }
.iht-hero__accent { font-style: italic; color: #c84b20; }
.iht-hero__subtitle {
  font-family: "Inter", sans-serif; font-size: 15.5px; line-height: 1.6; color: rgba(0, 0, 0, 0.62);
  max-width: 540px; margin-top: 20px;
}
@media (min-width: 768px) { .iht-hero__subtitle { font-size: 16.5px; } }
.iht-hero__stats { display: flex; flex-wrap: wrap; gap: 24px 44px; margin-top: 32px; }
.iht-hero__actions {
  display: flex; flex-wrap: wrap; align-items: center; gap: 28px; margin-top: 32px;
  padding-top: 28px; border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.iht-hero__cta-group { display: flex; flex-direction: column; gap: 14px; }
@media (min-width: 640px) { .iht-hero__cta-group { flex-direction: row; } }
.iht-hero__social-proof { display: flex; align-items: center; gap: 12px; }
.iht-hero__social-copy { font-size: 13px; color: rgba(0, 0, 0, 0.55); max-width: 160px; line-height: 1.35; }
.iht-hero__social-copy strong { font-weight: 600; color: rgba(0, 0, 0, 0.8); }
.iht-hero__grid { display: grid; grid-template-columns: 1fr; gap: 40px; align-items: center; }
@media (min-width: 1024px) { .iht-hero__grid { grid-template-columns: 1.05fr 1fr; gap: 32px; } }

/* iht-hero visual — Company > Jobs > Candidates > Hiring flow, not a candidate spotlight */
.iht-hero__flow { position: relative; display: none; }
@media (min-width: 900px) { .iht-hero__flow { display: flex; flex-direction: column; gap: 0; min-height: 440px; justify-content: center; } }
.iht-hero__flow-card {
  background: #FFFFFF; border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px 20px; display: flex; align-items: center; gap: 14px;
  box-shadow: 0 10px 24px rgba(20, 20, 20, 0.06);
}
.iht-hero__flow-card--active {
  border-color: rgba(199, 91, 46, 0.4);
  box-shadow: 0 16px 32px rgba(199, 91, 46, 0.14);
}
.iht-hero__flow-icon {
  width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; background: #F3EEE3;
}
.iht-hero__flow-card--active .iht-hero__flow-icon { background: #c84b20; }
.iht-hero__flow-text { display: flex; flex-direction: column; gap: 2px; }
.iht-hero__flow-label {
  font-family: "JetBrains Mono", monospace; font-size: 10px; letter-spacing: 0.08em; text-transform: uppercase; color: rgba(0,0,0,0.4);
}
.iht-hero__flow-title { font-family: "Playfair Display", serif; font-weight: 600; font-size: 16px; color: #141414; }
.iht-hero__flow-connector { display: flex; justify-content: flex-start; padding-left: 39px; }
.iht-hero__flow-connector span { width: 1px; height: 22px; background: repeating-linear-gradient(to bottom, rgba(199,91,46,0.5) 0 4px, transparent 4px 8px); }

/* ---------- hero right visual: live candidate match preview ---------- */
.iht-hero__visual {
  position: relative;
  display: none;
  min-height: 440px;
  border: 1px dashed rgba(0, 0, 0, 0.15);
  border-radius: 18px;
  background-color: #F3EEE3;
  background-image:
    linear-gradient(rgba(0, 0, 0, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.05) 1px, transparent 1px);
  background-size: 22px 22px;
}
@media (min-width: 1024px) { .iht-hero__visual { display: block; } }

.iht-hero__live-badge {
  position: absolute; top: 22px; left: 22px; z-index: 2;
  display: inline-flex; align-items: center; gap: 8px;
  background: #141414; color: #FFFFFF;
  font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.04em;
  padding: 8px 14px 8px 12px; border-radius: 20px;
}
.iht-hero__live-dot { width: 7px; height: 7px; border-radius: 50%; background: #2E9E5B; }

.iht-hero__stat-badge {
  position: absolute; bottom: 22px; right: 22px; z-index: 2;
  background: #FFFFFF; color: #141414;
  font-family: "JetBrains Mono", monospace; font-size: 12px; font-weight: 600; letter-spacing: 0.02em;
  padding: 12px 18px; border-radius: 20px;
  box-shadow: 0 14px 30px rgba(20, 20, 20, 0.14);
}

.iht-hero__preview-card {
  position: absolute; top: 92px; left: 50%; transform: translateX(-50%) rotate(-2deg);
  width: 78%; max-width: 300px;
  background: #FFFFFF; border-radius: 14px; padding: 26px;
  box-shadow: 0 26px 52px rgba(20, 20, 20, 0.16);
  display: flex; flex-direction: column; gap: 16px;
}
.iht-hero__preview-label {
  font-family: "JetBrains Mono", monospace; font-size: 10.5px; letter-spacing: 0.08em; text-transform: uppercase;
  color: rgba(0, 0, 0, 0.35);
}
.iht-hero__preview-copy { font-size: 13px; line-height: 1.55; color: rgba(0, 0, 0, 0.55); }

/* ---------- trusted strip ---------- */
.iht-trusted-strip { max-width: 1400px; margin: 0 auto; padding: 0 32px; margin-bottom: 16px; }
.iht-trusted-strip__inner {
  border-top: 1px solid rgba(0, 0, 0, 0.1); border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 24px 0; display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 16px;
}
.iht-trusted-strip__label {
  font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4); margin-right: 32px;
}
.iht-trusted-strip__firms { display: flex; flex-wrap: wrap; gap: 12px 40px; }
.iht-trusted-strip__firm { font-family: "JetBrains Mono", monospace; font-size: 13px; letter-spacing: 0.02em; color: rgba(0, 0, 0, 0.35); }

/* ---------- generic section ---------- */
.iht-section { padding: 64px 0; }
.iht-section--alt { background: #FAF7F1; }
.iht-section--border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.iht-section--border-top { border-top: 1px solid rgba(0, 0, 0, 0.1); }
.iht-section--border-y { border-top: 1px solid rgba(0, 0, 0, 0.1); border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.iht-section--dark { background: #141414; }
.iht-section__inner { max-width: 1300px; margin: 0 auto; padding: 0 20px; }
.iht-section__head { display: flex; flex-direction: column; justify-content: flex-end; gap: 24px; margin-bottom: 40px; }
@media (min-width: 768px) { .iht-section__head { flex-direction: row; align-items: flex-end; justify-content: space-between; } }
.iht-section__head--center { align-items: center; text-align: center; max-width: 600px; margin-left: auto; margin-right: auto; }
.iht-section__title { font-family: "Playfair Display", serif; font-weight: 600; color: #141414; line-height: 1.15; font-size: 32px; }
@media (min-width: 768px) { .iht-section__title { font-size: 42px; } }
.iht-section__title--light { color: #FFFFFF; }
.iht-section__lede { font-family: "Inter", sans-serif; font-size: 14.5px; color: rgba(0, 0, 0, 0.55); max-width: 320px; }
.iht-section__lede--italic { font-style: italic; }
.iht-section__lede--light { color: rgba(255,255,255,0.6); }

/* ---------- talent categories (candidate cards) ---------- */
.iht-category-grid { display: grid; grid-template-columns: 1fr; gap: 20px; }
@media (min-width: 640px) { .iht-category-grid { grid-template-columns: repeat(2, 1fr); } }
@media (min-width: 1024px) { .iht-category-grid { grid-template-columns: repeat(3, 1fr); } }

.iht-candidate-card {
  background: #FFFFFF; border: 1px solid rgba(0, 0, 0, 0.08); border-radius: 14px; padding: 26px;
  display: flex; flex-direction: column; gap: 16px;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}
.iht-candidate-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 32px rgba(20, 20, 20, 0.08);
  border-color: rgba(199, 91, 46, 0.32);
}
.iht-candidate-card__verified {
  display: inline-flex; align-items: center; gap: 6px; align-self: flex-start;
  font-family: "JetBrains Mono", monospace; font-size: 10px; font-weight: 500; letter-spacing: 0.06em;
  color: #c84b20; background: rgba(199, 91, 46, 0.08); border: 1px solid rgba(199, 91, 46, 0.25);
  padding: 5px 11px 5px 8px; border-radius: 20px;
}
.iht-candidate-card__top { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.iht-candidate-card__id { display: flex; align-items: center; gap: 12px; }
.iht-candidate-avatar {
  width: 50px; height: 50px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-family: "Playfair Display", serif; font-weight: 700; font-size: 16px; color: #FFFFFF;
  background: linear-gradient(135deg, #c84b20, #141414);
}
.iht-candidate-card__name { font-family: "Playfair Display", serif; font-weight: 600; font-size: 18px; color: #141414; line-height: 1.25; }
.iht-candidate-card__role { font-family: "JetBrains Mono", monospace; font-size: 10.5px; letter-spacing: 0.05em; color: #c84b20; margin-top: 4px; }
.iht-candidate-card__score {
  font-family: "JetBrains Mono", monospace; font-weight: 700; font-size: 11px; letter-spacing: 0.02em; color: #141414;
  background: #F3EEE3; padding: 6px 12px; border-radius: 20px; white-space: nowrap;
}
.iht-candidate-card__meta {
  display: flex; align-items: center; flex-wrap: wrap; gap: 14px;
  font-family: "Inter", sans-serif; font-size: 12px; color: rgba(0, 0, 0, 0.5);
}
.iht-candidate-card__meta span { display: flex; align-items: center; gap: 5px; }
.iht-candidate-card__tags { display: flex; flex-wrap: wrap; gap: 8px; }
.iht-candidate-card__footer {
  display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: auto;
  padding-top: 16px; border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.iht-candidate-card__avail {
  display: flex; align-items: center; gap: 7px;
  font-family: "JetBrains Mono", monospace; font-size: 10.5px; letter-spacing: 0.03em; color: rgba(0, 0, 0, 0.5);
}
.iht-candidate-card__dot { width: 6px; height: 6px; border-radius: 50%; background: #2E9E5B; }
.iht-candidate-card__dot--soon { background: #C7972E; }
.iht-candidate-card__cta {
  font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.03em;
  background: transparent; color: #141414; border: 1.5px solid rgba(0, 0, 0, 0.15); border-radius: 8px;
  padding: 9px 14px; display: flex; align-items: center; gap: 7px; cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.iht-candidate-card__cta:hover { background: #141414; color: #FFFFFF; border-color: #141414; }

.iht-tag-chip {
  font-family: "JetBrains Mono", monospace; font-size: 10.5px; letter-spacing: 0.02em; color: rgba(0, 0, 0, 0.6);
  background: #F3EEE3; border-radius: 20px; padding: 5px 12px;
}

.iht-category-callout {
  border: none; border-radius: 14px; background: #141414; padding: 28px;
  display: flex; flex-direction: column; justify-content: center; align-items: flex-start; gap: 12px;
  position: relative; overflow: hidden;
}
.iht-category-callout::before {
  content: ""; position: absolute; top: -30px; right: -30px; width: 100px; height: 100px;
  border-radius: 50%; background: rgba(199, 91, 46, 0.15);
}
.iht-category-callout__title { font-family: "Playfair Display", serif; color: #FFFFFF; font-size: 20px; font-weight: 600; line-height: 1.4; position: relative; }
.iht-category-callout__copy { font-family: "Inter", sans-serif; color: rgba(255, 255, 255, 0.55); font-size: 13px; line-height: 1.6; position: relative; }
.iht-category-callout__cta {
  font-family: "JetBrains Mono", monospace; display: flex; align-items: center; gap: 6px;
  font-size: 11.5px; letter-spacing: 0.02em; color: #c84b20; background: none; border: none;
  cursor: pointer; margin-top: 8px; position: relative;
}

/* ---------- workforce section head (stacked: eyebrow -> title -> subheading, mobile-safe) ---------- */
.iht-wf-head { display: flex; flex-direction: column; gap: 14px; margin-bottom: 40px; max-width: 100%; }
.iht-wf-head__lede {
  font-family: "Inter", sans-serif;
  font-size: 14.5px;
  line-height: 1.6;
  color: rgba(255,255,255,0.6);
  max-width: 640px;
}
@media (min-width: 768px) {
  .iht-wf-head__lede { font-size: 15.5px; }
}
@media (min-width: 1024px) {
  .iht-wf-head .iht-section__title { font-size: 36px; white-space: nowrap; }
  .iht-wf-head__lede { white-space: nowrap; max-width: none; }
}

/* ---------- Section 3: portal vs IPDI visual comparison ---------- */
.iht-contrast { display: grid; grid-template-columns: 1fr; gap: 20px; }
@media (min-width: 900px) { .iht-contrast { grid-template-columns: 1fr auto 1fr; align-items: stretch; } }
.iht-contrast__col {
  background: #FFFFFF; border: 1px solid rgba(0,0,0,0.08); padding: 32px 28px; display: flex; flex-direction: column; gap: 18px;
}
.iht-contrast__col--highlight { border: 1.5px solid #c84b20; background: #FFFDFA; box-shadow: 0 20px 40px rgba(199,91,46,0.1); }
.iht-contrast__label {
  font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(0,0,0,0.4);
}
.iht-contrast__col--highlight .iht-contrast__label { color: #c84b20; }
.iht-contrast__heading { font-family: "Playfair Display", serif; font-size: 22px; font-weight: 600; color: #141414; }
.iht-contrast__row { display: flex; align-items: flex-start; gap: 10px; font-size: 14px; color: rgba(0,0,0,0.65); line-height: 1.5; }
.iht-contrast__row svg { flex-shrink: 0; margin-top: 2px; }
.iht-contrast__vs {
  display: none; align-items: center; justify-content: center;
  font-family: "Playfair Display", serif; font-style: italic; font-size: 20px; color: rgba(0,0,0,0.3);
}
@media (min-width: 900px) { .iht-contrast__vs { display: flex; } }

/* ---------- How it works iht-timeline ---------- */
.iht-timeline { display: grid; grid-template-columns: 1fr; gap: 0; }
@media (min-width: 900px) { .iht-timeline { grid-template-columns: repeat(4, 1fr); } }
.iht-timeline__step { position: relative; padding: 0 20px 32px 0; }
.iht-timeline__num {
  font-family: "JetBrains Mono", monospace; font-size: 12px; color: #c84b20; letter-spacing: 0.08em; margin-bottom: 14px; display: block;
}
.iht-timeline__rail { position: relative; height: 2px; background: rgba(0,0,0,0.12); margin-bottom: 18px; }
.iht-timeline__dot { position: absolute; top: 50%; left: 2%; transform: translate(-50%, -50%); width: 12px; height: 12px; border-radius: 50%; background: #c84b20; }
.iht-timeline__icon-wrap {
  width: 52px; height: 52px; border-radius: 50%; background: #141414; display: flex; align-items: center; justify-content: center; margin-bottom: 16px;
}
.iht-timeline__title { font-family: "Playfair Display", serif; font-size: 19px; font-weight: 600; color: #141414; margin-bottom: 8px; }
.iht-timeline__copy { font-size: 13.5px; line-height: 1.55; color: rgba(0,0,0,0.55); max-width: 240px; }
.iht-timeline__arrow { display: none; position: absolute; top: 25px; right: 5px; color: rgba(0,0,0,0.2); }
@media (min-width: 900px) { .iht-timeline__arrow { display: block; } }

/* ---------- Hiring support cards (secondary, section 6) ---------- */
.iht-support-grid { display: grid; grid-template-columns: 1fr; gap: 16px; }
@media (min-width: 640px) { .iht-support-grid { grid-template-columns: repeat(2, 1fr); } }
@media (min-width: 1024px) { .iht-support-grid { grid-template-columns: repeat(3, 1fr); } }
.iht-support-card {
  background: #FFFFFF; border: 1px solid rgba(0,0,0,0.08); padding: 22px; display: flex; align-items: center; gap: 14px;
}
.iht-support-card__icon {
  width: 36px; height: 36px; border-radius: 8px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: #F3EEE3;
}
.iht-support-card__title { font-size: 14px; font-weight: 600; color: #141414; }

.iht-hs-scroll-cta { margin-top: 32px; display: flex; justify-content: center; }

/* ---------- Workforce/program plan cards ---------- */
.iht-wf-grid { display: grid; grid-template-columns: 1fr; gap: 24px; }
@media (min-width: 900px) { .iht-wf-grid { grid-template-columns: repeat(2, 1fr); } }
.iht-wf-card {
  background: #1B1B1B; border: 1px solid rgba(255,255,255,0.08); padding: 32px 28px; display: flex; flex-direction: column; gap: 22px;
  text-align: left; width: 100%; font-family: inherit; position: relative; transition: border-color 0.2s ease, background 0.2s ease;
}
.iht-wf-card--featured { border-color: rgba(199,91,46,0.5); background: #201812; }
.iht-wf-card--selected { border-color: #c84b20; box-shadow: 0 0 0 1px #c84b20; }
.iht-wf-card__ribbon {
  position: absolute; top: -11px; left: 28px; background: #c84b20; color: #FFFFFF;
  font-family: "JetBrains Mono", monospace; font-size: 10px; letter-spacing: 0.1em; text-transform: uppercase;
  padding: 4px 10px; font-weight: 600;
}

/* -- overview -- */
.iht-wf-card__top { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.iht-wf-card__num { font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.1em; color: rgba(255,255,255,0.35); }
.iht-wf-card__duration {
  font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.06em; text-transform: uppercase;
  color: rgba(199,91,46,0.9); border: 1px solid rgba(199,91,46,0.4); padding: 4px 10px; border-radius: 20px;
  display: inline-flex; align-items: center; gap: 5px;
}
.iht-wf-card__title { font-family: "Playfair Display", serif; font-size: 22px; line-height: 1.25; font-weight: 600; color: #FFFFFF; }
.iht-wf-card__copy { font-size: 13px; line-height: 1.6; color: rgba(255,255,255,0.55); }

/* price gets its own row so it reads as a distinct, scannable figure — not buried in a mono line */
.iht-wf-card__price {
  display: flex; align-items: baseline; gap: 8px; font-family: "JetBrains Mono", monospace;
  font-size: 12px; letter-spacing: 0.04em; text-transform: uppercase; color: rgba(255,255,255,0.45);
}
.iht-wf-card__price span { font-family: "Playfair Display", serif; color: #FFFFFF; font-size: 26px; font-weight: 700; letter-spacing: 0; text-transform: none; }
.iht-wf-card__price em { color: #c84b20; font-style: normal; font-weight: 700; }
.iht-wf-card__divider { height: 1px; background: rgba(255,255,255,0.08); margin: 0; }

/* -- shared block styling -- */
.iht-wf-block { display: flex; flex-direction: column; gap: 14px; padding: 22px; border-radius: 2px; }
.iht-wf-block__head { display: flex; align-items: center; gap: 12px; padding-bottom: 14px; border-bottom: 1px solid rgba(255,255,255,0.08); }
.iht-wf-block__icon { width: 34px; height: 34px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
.iht-wf-block__head-text { display: flex; flex-direction: column; gap: 3px; }
.iht-wf-block__eyebrow { font-family: "JetBrains Mono", monospace; font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase; font-weight: 600; }
.iht-wf-block__title { font-family: "Playfair Display", serif; font-size: 17px; font-weight: 600; line-height: 1.2; }

/* -- workforce development block: the main product, given the most visual weight -- */
.iht-wf-block--dev { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.12); }
.iht-wf-block__icon--dev { background: rgba(255,255,255,0.12); }
.iht-wf-block__eyebrow--dev { color: rgba(255,255,255,0.4); }
.iht-wf-block__title--dev { color: #FFFFFF; }
.iht-wf-block__lede { font-size: 13px; line-height: 1.5; color: rgba(255,255,255,0.55); }
.iht-wf-modules { display: flex; flex-direction: column; gap: 12px; margin-top: 2px; }
.iht-wf-module { display: flex; align-items: center; gap: 12px; }
.iht-wf-module__icon { width: 32px; height: 32px; border-radius: 8px; background: rgba(199,91,46,0.15); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.iht-wf-module__label { font-size: 14px; line-height: 1.3; color: rgba(255,255,255,0.85); }
.iht-wf-outcome {
  align-self: flex-start; display: inline-flex; align-items: center; gap: 6px; margin-top: 4px;
  font-family: "JetBrains Mono", monospace; font-size: 11px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase;
  color: #141414; background: #FFFFFF; padding: 7px 12px; border-radius: 20px;
}

/* -- hiring support block: the USP, given equal visual clarity but a distinct rust identity so the two blocks never blur together -- */
.iht-wf-block--support { background: rgba(199,91,46,0.1); border: 1px solid rgba(199,91,46,0.4); }
.iht-wf-block__icon--support { background: rgba(199,91,46,0.22); }
.iht-wf-block__head--support { border-bottom-color: rgba(199,91,46,0.25); }
.iht-wf-block__eyebrow--support { color: rgba(199,91,46,0.75); }
.iht-wf-block__title--support { color: #c84b20; }
.iht-wf-badge {
  align-self: flex-start; display: inline-flex; align-items: center; gap: 6px;
  font-family: "JetBrains Mono", monospace; font-size: 10px; letter-spacing: 0.05em; text-transform: uppercase; font-weight: 700;
  color: #141414; background: #c84b20; padding: 6px 11px; border-radius: 20px;
}
.iht-wf-checklist { display: grid; grid-template-columns: 1fr; gap: 11px; margin-top: 2px; }
@media (min-width: 460px) { .iht-wf-checklist { grid-template-columns: 1fr 1fr; gap: 10px 16px; } }
.iht-wf-check { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; line-height: 1.4; color: rgba(255,255,255,0.75); }
.iht-wf-check svg { flex-shrink: 0; margin-top: 2px; }

/* -- value highlight -- */
.iht-wf-value-box {
  display: flex; align-items: flex-start; gap: 12px; padding: 16px 18px; background: #141414; border-left: 2px solid #c84b20;
}
.iht-wf-value-box svg { flex-shrink: 0; margin-top: 2px; }
.iht-wf-value-box p { font-size: 13px; line-height: 1.55; color: rgba(255,255,255,0.72); }

/* -- select button -- */
.iht-wf-card__select-btn {
  margin-top: 2px; font-family: "JetBrains Mono", monospace; font-size: 12px; letter-spacing: 0.04em; text-transform: uppercase;
  color: rgba(255,255,255,0.55); background: transparent; border: 1px solid rgba(255,255,255,0.18); cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px 20px; transition: all 0.2s ease;
}
.iht-wf-card__select-btn:hover { border-color: rgba(199,91,46,0.5); color: #FFFFFF; }
.iht-wf-card--selected .iht-wf-card__select-btn { color: #c84b20; border-color: #c84b20; background: rgba(199,91,46,0.08); }

.iht-wf-summary {
  margin-top: 28px; padding: 24px 28px; background: #201812; border: 1px solid rgba(199,91,46,0.3);
  display: flex; align-items: center; justify-content: space-between; gap: 24px; flex-wrap: wrap;
}
.iht-wf-summary__label { font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase; color: rgba(199,91,46,0.9); }
.iht-wf-summary__title { font-family: "Playfair Display", serif; font-size: 19px; font-weight: 600; color: #FFFFFF; margin: 4px 0; }
.iht-wf-summary__copy { font-size: 13px; color: rgba(255,255,255,0.55); max-width: 480px; }

/* ---------- Section 7: Budget Transformation infographic (Traditional vs IPDI) ---------- */
.iht-budget-tag {
  display: flex; align-items: center; justify-content: center; gap: 10px; margin: 0 auto 40px; width: fit-content;
  font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(0,0,0,0.45);
}
.iht-budget-tag__pill {
  display: inline-flex; align-items: center; gap: 6px; color: #141414; font-weight: 600;
  border: 1px solid rgba(0,0,0,0.18); padding: 6px 14px; border-radius: 20px; background: #FFFFFF;
}

.iht-budget-flow { display: grid; grid-template-columns: 1fr; gap: 28px; align-items: stretch; position: relative; }
@media (min-width: 900px) { .iht-budget-flow { grid-template-columns: 1fr auto 1fr; gap: 0; } }

.iht-budget-col { background: #FFFFFF; padding: 32px 30px 34px; display: flex; flex-direction: column; position: relative; }
.iht-budget-col--traditional { border: 1.5px solid rgba(178,53,53,0.28); background: linear-gradient(180deg,#FFF8F7 0%,#FFFFFF 55%); }
.iht-budget-col--ipdi {
  border: 1.5px solid #c84b20; background: linear-gradient(180deg,#FFFDFA 0%,#FFFFFF 55%);
  box-shadow: 0 28px 56px rgba(199,91,46,0.14);
}
@media (min-width: 900px) { .iht-budget-col--traditional { margin-right: 32px; } .iht-budget-col--ipdi { margin-left: 32px; } }
.iht-budget-col--ipdi::before {
  content: "RECOMMENDED"; position: absolute; top: -11px; left: 30px;
  background: #c84b20; color: #FFFFFF; font-family: "JetBrains Mono", monospace; font-size: 10px;
  letter-spacing: 0.1em; padding: 4px 10px; font-weight: 600;
}

.iht-budget-col__head { display: flex; align-items: center; gap: 12px; margin-bottom: 26px; }
.iht-budget-col__icon-badge {
  width: 42px; height: 42px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center;
}
.iht-budget-col--traditional .iht-budget-col__icon-badge { background: rgba(178,53,53,0.12); }
.iht-budget-col--ipdi .iht-budget-col__icon-badge { background: rgba(199,91,46,0.15); }
.iht-budget-col__label { font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase; }
.iht-budget-col--traditional .iht-budget-col__label { color: #B23535; }
.iht-budget-col--ipdi .iht-budget-col__label { color: #c84b20; }
.iht-budget-col__heading { font-family: "Playfair Display", serif; font-size: 19px; font-weight: 600; color: #141414; margin-top: 3px; line-height: 1.3; }

.iht-budget-steps { display: flex; flex-direction: column; }
.iht-budget-step { display: flex; align-items: center; gap: 14px; }
.iht-budget-step__icon {
  width: 38px; height: 38px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center;
}
.iht-budget-col--traditional .iht-budget-step__icon { background: #F6E9E9; }
.iht-budget-col--ipdi .iht-budget-step__icon { background: rgba(199,91,46,0.14); }
.iht-budget-step__label { font-size: 14px; font-weight: 600; color: #141414; line-height: 1.3; }
.iht-budget-connector { display: flex; padding-left: 18px; }
.iht-budget-connector span { width: 1px; height: 20px; display: block; }
.iht-budget-col--traditional .iht-budget-connector span { background: repeating-linear-gradient(to bottom, rgba(178,53,53,0.35) 0 4px, transparent 4px 8px); }
.iht-budget-col--ipdi .iht-budget-connector span { background: repeating-linear-gradient(to bottom, rgba(199,91,46,0.4) 0 4px, transparent 4px 8px); }

.iht-budget-col__terminal { margin-top: 18px; display: flex; align-items: center; gap: 10px; padding: 13px 16px; }
.iht-budget-col--traditional .iht-budget-col__terminal { background: #FBEEEE; border-left: 2px solid #B23535; }
.iht-budget-col--ipdi .iht-budget-col__terminal { background: #141414; border-left: 2px solid #c84b20; }
.iht-budget-col__terminal-text { font-size: 12.5px; }
.iht-budget-col--traditional .iht-budget-col__terminal-text { color: #8C2B2B; font-weight: 600; }
.iht-budget-col--ipdi .iht-budget-col__terminal-text { color: #FFFFFF; font-weight: 600; font-size: 13.5px; }

.iht-budget-becomes { display: none; }
@media (min-width: 900px) {
  .iht-budget-becomes {
    display: flex; align-items: center; justify-content: center; position: relative; width: 0;
  }
  .iht-budget-becomes__badge {
    position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
    width: 54px; height: 54px; border-radius: 50%; background: #141414;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 10px 26px rgba(0,0,0,0.22); z-index: 2;
  }
}
.iht-budget-becomes-mobile { display: flex; justify-content: center; margin: -8px 0 0; }
@media (min-width: 900px) { .iht-budget-becomes-mobile { display: none; } }
.iht-budget-becomes-mobile__badge {
  width: 44px; height: 44px; border-radius: 50%; background: #141414; display: flex; align-items: center; justify-content: center;
}

/* -- value statement panel -- */
.iht-value-panel { margin-top: 48px; background: #141414; padding: 44px 40px; }
.iht-value-panel__inner { max-width: 640px; margin: 0 auto; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 14px; }
.iht-value-panel__eyebrow {
  font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(199,91,46,0.85);  text-align:start;
}
.iht-value-panel__title { font-family: "Playfair Display", serif; font-size: 26px; font-weight: 600; color: #FFFFFF; line-height: 1.3; }
@media (min-width: 768px) { .iht-value-panel__title { font-size: 30px; } }
.iht-value-panel__copy { font-size: 14.5px; line-height: 1.6; color: rgba(255,255,255,0.6); }
.iht-value-panel__checklist { display: flex; flex-wrap: wrap; justify-content: center; gap: 12px 28px; margin-top: 8px; }
.iht-value-check {
  display: flex; align-items: center; gap: 8px; font-size: 13.5px; font-weight: 600; color: #FFFFFF;
}
.iht-value-check__icon {
  width: 24px; height: 24px; border-radius: 50%; background: rgba(199,91,46,0.15);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}

/* ---------- final cta ---------- */
.iht-final-cta { display: flex; flex-direction: column; align-items: center; text-align: center; gap: 20px; }
.iht-final-cta__title { font-family: "Playfair Display", serif; font-size: 34px; font-weight: 600; color: #FFFFFF; }
@media (min-width: 768px) { .iht-final-cta__title { font-size: 46px; } }
.iht-final-cta__copy { font-size: 15px; color: rgba(255,255,255,0.6); max-width: 440px; }
.iht-final-cta__actions { display: flex; flex-wrap: wrap; justify-content: center; gap: 16px; margin-top: 12px; }
.iht-final-cta__fine-print {
  font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.06em; text-transform: uppercase; color: rgba(255,255,255,0.35); margin-top: 8px;
}

/* ---------- no-hr-box (missing in original preview, added for completeness) ---------- */
.iht-no-hr-box {
  margin-top: 24px; display: flex; align-items: flex-start; gap: 14px;
  background: #FFFFFF; border: 1px solid rgba(199,91,46,0.3); padding: 20px 22px;
}
.iht-no-hr-box__icon {
  width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; background: rgba(199,91,46,0.1);
}
.iht-no-hr-box__title { font-family: "Playfair Display", serif; font-size: 16px; font-weight: 600; color: #141414; margin-bottom: 4px; }
.iht-no-hr-box__copy { font-size: 13.5px; line-height: 1.55; color: rgba(0,0,0,0.55); max-width: 480px; }

/* =====================================================================
   MOBILE VIEW — HireTalentPage
   Scope: phones, max-width: 767px
   ===================================================================== */

@media (max-width: 767px) {

  /* ---------- global section rhythm ---------- */
  .iht-section { padding: 44px 0; }
  .iht-section__inner { padding: 0 25px; }
  .iht-section__title { font-size: 26px; line-height: 1.2; }
  .iht-section__lede { font-size: 13px; max-width: 100%; }
  .iht-section__head { gap: 16px; margin-bottom: 28px; }
  .iht-section__head--center { max-width: 100%; }

  .iht-eyebrow { margin-bottom: 12px; }
  .iht-eyebrow__label { font-size: 10px; }

  .iht-btn { padding: 14px 22px; font-size: 12px; width: 100%; }
  .iht-btn--small { padding: 14px 22px; }

  /* ---------- hero ---------- */
  .iht-hero__inner { padding: 0 16px; padding-top: 36px; padding-bottom: 36px; }
  .iht-hero__kicker { font-size: 11px; margin-bottom: 12px; }
  .iht-hero__title { font-size: 28px; line-height: 1.15; }
  .iht-hero__subtitle { font-size: 14px; margin-top: 14px; }
  .iht-hero__stats { gap: 18px 28px; margin-top: 24px; }
  .iht-mini-stat__value { font-size: 22px; }
  .iht-mini-stat__label { font-size: 10px; margin-top: 6px; }
  .iht-hero__actions { margin-top: 24px; padding-top: 20px; gap: 14px; }
  .iht-hero__cta-group { width: 100%; gap: 10px; }

  /* ---------- trusted strip ---------- */
  .iht-trusted-strip { padding: 0 16px; }
  .iht-trusted-strip__inner { padding: 16px 0; gap: 10px; }
  .iht-trusted-strip__label { font-size: 10px; margin-right: 0; width: 100%; }
  .iht-trusted-strip__firms { gap: 8px 20px; }
  .iht-trusted-strip__firm { font-size: 11.5px; }

  /* ---------- talent categories ---------- */
  .iht-category-grid { gap: 16px; }
  .iht-candidate-card { padding: 20px; gap: 14px; }
  .iht-candidate-card__name { font-size: 16.5px; }

  /* ---------- why IPDI (portal vs IPDI contrast) ---------- */
  .iht-contrast { gap: 14px; }
  .iht-contrast__col { padding: 22px 18px; gap: 14px; }
  .iht-contrast__heading { font-size: 18px; }
  .iht-contrast__row { font-size: 13px; }

  /* ---------- how it works timeline ---------- */
  .iht-timeline__step { padding: 0 0 24px 0; }
  .iht-timeline__icon-wrap { width: 44px; height: 44px; margin-bottom: 12px; }
  .iht-timeline__title { font-size: 17px; }
  .iht-timeline__copy { font-size: 12.5px; max-width: 100%; }

  /* ---------- budget transformation infographic ---------- */
  .iht-budget-tag { flex-direction: column; gap: 8px; margin-bottom: 28px; text-align: center; }
  .iht-budget-flow { gap: 20px; }
  .iht-budget-col { padding: 24px 18px 26px; }
  .iht-budget-col__heading { font-size: 16.5px; }
  .iht-budget-step__label { font-size: 13px; }
  .iht-budget-col__terminal-text { font-size: 12px; }

  /* value statement panel */
  .iht-value-panel__eyebrow { text-align:start; margin-right:52px; }
  .iht-value-panel { padding: 30px 20px; margin-top: 32px;  text-align:start; }
  .iht-value-panel__title { font-size: 21px;  text-align:start; }
  .iht-value-panel__copy { font-size: 13px; 
  text-align:start; }
  .iht-value-panel__checklist { gap: 10px 18px; 
   
    display: flex;
    flex-wrap: wrap;
    justify-content: start;

  }
  .iht-value-check { font-size: 12.5px; }

  .iht-hs-scroll-cta { margin-top: 24px; }
  .iht-hs-scroll-cta .iht-btn { width: 100%; }

  /* ---------- workforce development section head ---------- */
  .iht-wf-head { gap: 10px; margin-bottom: 28px; }
  .iht-wf-head .iht-section__title {
    font-size: 26px;
    white-space: normal; /* undo desktop nowrap */
  }
  .iht-wf-head__lede {
    font-size: 13.5px;
    white-space: normal; /* undo desktop nowrap */
    max-width: 100%;
  }

  /* ---------- workforce plan cards ---------- */
  .iht-wf-grid { gap: 18px; }
  .iht-wf-card { padding: 22px 18px; gap: 18px; }
  .iht-wf-card__title { font-size: 19px; }
  .iht-wf-card__copy { font-size: 12.5px; }
  .iht-wf-card__price span { font-size: 22px; }

  .iht-wf-block { padding: 16px; gap: 12px; }
  .iht-wf-block__title { font-size: 15.5px; }
  .iht-wf-module__label { font-size: 13px; }

  .iht-wf-checklist {
    grid-template-columns: 1fr; /* single column on phones */
    gap: 9px;
  }
  .iht-wf-check { font-size: 12.5px; }

  .iht-wf-value-box { padding: 14px 16px; }
  .iht-wf-value-box p { font-size: 12.5px; }

  .iht-wf-card__select-btn {
    width: 100%;
    padding: 13px 16px;
    font-size: 11.5px;
  }

  .iht-wf-summary {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
    padding: 20px 18px;
    margin-top: 20px;
  }
  .iht-wf-summary__title { font-size: 17px; }
  .iht-wf-summary__copy { font-size: 12.5px; }

  /* ---------- final CTA ---------- */
  .iht-final-cta__title { font-size: 28px; }
  .iht-final-cta__copy { font-size: 13.5px; max-width: 100%; }
  .iht-final-cta__actions { flex-direction: column; width: 100%; gap: 12px; }
  .iht-final-cta__actions .iht-btn { width: 100%; }
  .iht-final-cta__fine-print { font-size: 10px; text-align: center; }
}

.iht-mini-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.iht-mini-stat__value {
  font-family: "Playfair Display", serif;
  font-weight: 700;
  font-size: 26px;
  color: #141414;
  line-height: 1;
}
.iht-mini-stat__suffix {
  color: #c84b20;
}
.iht-mini-stat__label {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  display: block;
}


`;

function Eyebrow({ children, dark, center }) {
  return (
    <div className={`iht-eyebrow ${dark ? "iht-eyebrow--dark" : ""} ${center ? "iht-eyebrow--center" : ""}`}>
      <span className="iht-eyebrow__line" />
      <span className="iht-eyebrow__label">{children}</span>
    </div>
  );
}

function MiniStat({ value, suffix, label }) {
  return (
    <div className="iht-mini-stat">
      <span className="iht-mini-stat__value">
        {value}
        {suffix && <sup className="iht-mini-stat__suffix">{suffix}</sup>}
      </span>
      <span className="iht-mini-stat__label">{label}</span>
    </div>
  );
}

function CandidateCard({ initials, name, role, score, location, experience, tags, status }) {
  return (
    <div className="iht-candidate-card">
      <span className="iht-candidate-card__verified">
        <BadgeCheck size={12} /> PORTFOLIO VERIFIED
      </span>

      <div className="iht-candidate-card__top">
        <div className="iht-candidate-card__id">
          <div className="iht-candidate-avatar">{initials}</div>
          <div>
            <div className="iht-candidate-card__name">{name}</div>
            <div className="iht-candidate-card__role">{role}</div>
          </div>
        </div>
        <span className="iht-candidate-card__score">{score}% MATCH</span>
      </div>

      <div className="iht-candidate-card__meta">
        <span>{location}</span>
        <span>{experience}</span>
      </div>

      <div className="iht-candidate-card__tags">
        {tags.map((t) => (
          <span className="iht-tag-chip" key={t}>{t}</span>
        ))}
      </div>

      <div className="iht-candidate-card__footer">
        <span className="iht-candidate-card__avail">
          <span className={`iht-candidate-card__dot${status === "soon" ? " iht-candidate-card__dot--soon" : ""}`} />
          {status === "soon" ? "Available soon" : "Available now"}
        </span>
        <button className="iht-candidate-card__cta">
          View Profile <ArrowRight size={13} />
        </button>
      </div>
    </div>
  );
}

const scrollToSection = (id) => {
  const section = document.getElementById(id);

  if (section) {
    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

const HERO_FLOW = [
  { icon: Building2, label: "Step 1", title: "Company", active: true },
  { icon: Briefcase, label: "Step 2", title: "Jobs" },
  { icon: Users, label: "Step 3", title: "Candidates" },
  { icon: CheckCircle2, label: "Step 4", title: "Hiring" },
];

const FIRMS = [
  "Architecture Firms",
  "Interior Design Studios",
  "Construction Companies",
  "Real Estate Developers",
  "Engineering Consultants",
];

const TALENT_CATEGORIES = [
  {
    initials: "AS",
    name: "Aditi Sharma",
    role: "Junior Architect",
    score: "94",
    location: "Pune, IN",
    experience: "1.5 yrs trained",
    tags: ["AUTOCAD", "REVIT / BIM", "SITE VISITS"],
    status: "available",
  },
  {
    initials: "RM",
    name: "Rohan Mehta",
    role: "Interior Designer",
    score: "91",
    location: "Mumbai, IN",
    experience: "2 yrs trained",
    tags: ["SKETCHUP", "3DS MAX", "CLIENT COMMS"],
    status: "available",
  },
  {
    initials: "PN",
    name: "Priya Nair",
    role: "3D Visualizer",
    score: "96",
    location: "Bengaluru, IN",
    experience: "1 yr trained",
    tags: ["V-RAY", "LUMION", "RENDERING"],
    status: "soon",
  },
  {
    initials: "KV",
    name: "Karan Verma",
    role: "Site Engineer",
    score: "89",
    location: "Ahmedabad, IN",
    experience: "2.5 yrs trained",
    tags: ["SITE SUPERVISION", "ESTIMATION", "DOCS"],
    status: "available",
  },
  {
    initials: "IR",
    name: "Ishaan Rao",
    role: "Landscape Designer",
    score: "90",
    location: "Jaipur, IN",
    experience: "1.5 yrs trained",
    tags: ["SITE PLANNING", "PLANTING", "AUTOCAD"],
    status: "soon",
  },
];

const GENERIC_PORTAL = [
  "Generic candidates, any industry",
  "Manual resume-by-resume hiring",
  "No AEC-specific screening",
  "No support if you get stuck",
];

const IPDI_WAY = [
  "AEC-specific talent pool only",
  "Smart, role-matched shortlists",
  "Connected to colleges & fresh graduate pipeline",
  "A long-term workforce partner, not a one-time vendor",
];

const HOW_IT_WORKS = [
  { icon: Building2, title: "Register Company", copy: "Create your employer account and company profile in minutes." },
  { icon: Briefcase, title: "Post Jobs", copy: "Publish your openings and reach industry-specific professionals." },
  { icon: FileText, title: "Review Applications", copy: "Manage every candidate through your employer dashboard." },
  { icon: UserCheck, title: "Hire Talent", copy: "Review your shortlist and select the right fit for your team." },
];

const SUPPORT_SERVICES = [
  { icon: Megaphone, title: "Job Posting Assistance" },
  { icon: Search, title: "Candidate Sourcing" },
  { icon: FileText, title: "Resume Screening" },
  { icon: CalendarCheck, title: "Interview Coordination" },
  { icon: BadgeCheck, title: "Shortlisting" },
  { icon: CheckCircle2, title: "Offer Follow-up" },
];

const WORKFORCE_PROGRAMS = [
  {
    id: "foundation",
    num: "01",
    duration: "2 months",
    featured: false,
    title: "Probation Accelerator — Foundation",
    copy: "Builds core workplace and drafting fundamentals so new hires can contribute from day one.",
    price: "39,000",
    modules: [
      { icon: Smile, label: "Soft skill training" },
      { icon: Compass, label: "AutoCAD drafting standards" },
      { icon: Wrench, label: "Construction drawings" },
      { icon: Wrench, label: "Services drawings & consultant coordination" },
    ],
  },
  {
    id: "performance",
    num: "02",
    duration: "3 months",
    featured: true,
    title: "Probation Accelerator — Performance",
    copy: "Strengthens technical capability with advanced BIM skills for real project performance.",
    price: "49,000",
    modules: [
      { icon: Smile, label: "Soft skill training" },
      { icon: Compass, label: "AutoCAD drafting standards" },
      { icon: Wrench, label: "Construction drawings" },
      { icon: Wrench, label: "Services drawings & consultant coordination" },
      { icon: Boxes, label: "BIM professional program" },
    ],
  },
];

const HIRING_SUPPORT_ITEMS = [
  "Dedicated Hiring Coordinator",
  "Job Requirement Consultation",
  "Job Posting on IPDI",
  "Candidate Sourcing",
  "Resume Screening",
  "Candidate Shortlisting",
  "Interview Coordination",
  "Candidate Follow-up",
];

const TRADITIONAL_FLOW = [
  { icon: Wallet, label: "Hiring Budget" },
  { icon: IndianRupee, label: "Recruitment Agency Fee" },
  { icon: UserCheck, label: "Candidate Provided" },
  { icon: GraduationCap, label: "Company Trains Employee, On Their Own" },
];

const IPDI_FLOW = [
  { icon: Wallet, label: "Same Hiring Budget" },
  { icon: Sparkles, label: "Invested in Workforce Development" },
  { icon: UserCog, label: "Dedicated Hiring Coordinator Included" },
  { icon: Megaphone, label: "Job Posting, Screening & Interviews" },
  { icon: GraduationCap, label: "Structured Probation Training" },
];

export default function HireTalentPage() {
  const [selectedPlan, setSelectedPlan] = useState("foundation");
  const activePlan = WORKFORCE_PROGRAMS.find((p) => p.id === selectedPlan);

  return (
    <div className="iht-hire-page">
      <style>{STYLES}</style>
      {/* <div className="iht-hire-page__topline" /> */}

      {/* HERO — registration-first */}
      <section className="iht-hero">
        <div className="iht-hero__inner">
          <div className="iht-hero__grid">
            <div>
              <div className="iht-hero__kicker">
                IPDI <span>/</span> HIRE TALENT
              </div>

              <h1 className="iht-hero__title">  
               Connect with the Right Architecture &amp; {" "}
                <span className="iht-hero__accent">Design Talent.</span>
              </h1>

              <p className="iht-hero__subtitle">
                Register your company, post jobs, connect with industry-specific talent,
                 and access dedicated hiring support whenever you need it.
              </p>

              {/* <div className="iht-hero__stats">
                <MiniStat value="2,400" suffix="+" label="Companies registered" />
                <MiniStat value="12,000" suffix="+" label="AEC professionals" />
                <MiniStat value="Free" label="To register & post" />
              </div> */}

              <div className="iht-hero__stats">
                <MiniStat value="500" suffix="+" label="Companies registered" />
                <MiniStat value="5K" suffix="+" label="AEC professionals" />
                <MiniStat value="Free to" label="register & post" />
              </div>

              <div className="iht-hero__actions">
                <div className="iht-hero__cta-group">
                  {/* <button className="iht-btn iht-btn--primary">
                    REGISTER YOUR COMPANY <ArrowRight size={17} />
                  </button> */}

             <a href={portalLink("/company-register")} className="iht-btn iht-btn--primary"
 style={{ textDecoration: "none" }} >
REGISTER TO HIRE <ArrowRight size={17} /> </a>

                  {/* <button className="iht-btn iht-btn--outline">POST YOUR FIRST JOB</button> */}

 <a href={portalLink("/company-login")} className="iht-btn iht-btn--outline" >POST YOUR FIRST JOB  </a>

                </div>
              </div>
            </div>

            {/* Right side — live candidate match preview */}
            <div className="iht-hero__visual">
              <span className="iht-hero__live-badge">
                <span className="iht-hero__live-dot" /> Matching live
              </span>

              <div className="iht-hero__preview-card">
                <span className="iht-hero__preview-label">CANDIDATE FILE — 014</span>

                <div className="iht-candidate-card__id">
                  <div className="iht-candidate-avatar">AS</div>
                  <div>
                    <div className="iht-candidate-card__name">Aditi Sharma</div>
                    <div className="iht-candidate-card__role">Junior Architect</div>
                  </div>
                </div>

                <p className="iht-hero__preview-copy">
                  Portfolio-reviewed · Revit &amp; site-ready · Available now
                </p>

                <div className="iht-candidate-card__tags">
                  <span className="iht-tag-chip">AUTOCAD</span>
                  <span className="iht-tag-chip">REVIT</span>
                  <span className="iht-tag-chip">94% MATCH</span>
                </div>
              </div>

              <span className="iht-hero__stat-badge">500+ trained candidates</span>
            </div>
          </div>
        </div>
      </section>

      {/* TRUSTED BY */}
      <section className="iht-trusted-strip">
        <div className="iht-trusted-strip__inner">
          <span className="iht-trusted-strip__label">Built for the AEC industry</span>
          <div className="iht-trusted-strip__firms">
            {FIRMS.map((f) => (
              <span key={f} className="iht-trusted-strip__firm">{f}</span>
            ))}
          </div>
        </div>
      </section>

      {/* TALENT CATEGORIES */}
      {/* <section id="talent-categories" className="iht-section">
        <div className="iht-section__inner">
          <div className="iht-section__head">
            <div>
              <Eyebrow>Talent categories</Eyebrow>
              <h2 className="iht-section__title">
                Hire For the Role You <span className="iht-hero__accent">Actually Need</span>
              </h2>
            </div>
            <p className="iht-section__lede">
              Every candidate below is portfolio-reviewed and skill-scored
              before they ever reach your inbox.
            </p>
          </div>

          <div className="iht-category-grid">
            {TALENT_CATEGORIES.map((c) => (
              <CandidateCard key={c.name} {...c} />
            ))}

            <div className="iht-category-callout">
              <p className="iht-category-callout__title">
                Don't see the profile you're hiring for?
              </p>
              <p className="iht-category-callout__copy">
                Tell us the requirement — we'll match or train candidates
                against it.
              </p>

              <a
                href={portalLink("/company-login")}
                className="iht-category-callout__cta"
                style={{ textDecoration: "none" }}
              >
                Post a requirement <ArrowRight size={13} />
              </a>
            </div>
          </div>
        </div>
      </section> */}

      {/* WHY REGISTER — why IPDI over a generic portal (absorbs the old comparison-table section) */}
      <section className="iht-section">
        <div className="iht-section__inner">
          <div className="iht-section__head--center">
            <Eyebrow center>Why IPDI exists</Eyebrow>
            <h2 className="iht-section__title">
              More Than <span className="iht-hero__accent">Just a Job Portal</span>
            </h2>
            <p className="iht-section__lede" style={{ maxWidth: 480, marginTop: 8 }}>
              Generic job portals weren't built for this industry. Here's the difference.
            </p>
          </div>

          <div className="iht-contrast" style={{ marginTop: 40 }}>
            <div className="iht-contrast__col">
              <span className="iht-contrast__label">Generic Job Portal</span>
              <h3 className="iht-contrast__heading">Hire on your own, with none of the context</h3>
              {GENERIC_PORTAL.map((row) => (
                <div className="iht-contrast__row" key={row}>
                  <X size={15} color="rgba(0,0,0,0.3)" strokeWidth={2} />
                  {row}
                </div>
              ))}
            </div>

            <div className="iht-contrast__vs">vs</div>

            <div className="iht-contrast__col iht-contrast__col--highlight">
              <span className="iht-contrast__label">IPDI</span>
              <h3 className="iht-contrast__heading">Built for AEC, with help when you need it</h3>
              {IPDI_WAY.map((row) => (
                <div className="iht-contrast__row" key={row}>
                  <CheckCircle2 size={15} color={RUST} strokeWidth={2} />
                  {row}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS — horizontal iht-timeline */}
      <section className="iht-section iht-section--alt iht-section--border-y">
        <div className="iht-section__inner">
          <div className="iht-section__head--center">
            <Eyebrow center>How it works</Eyebrow>
            <h2 className="iht-section__title">
              Start Hiring in <span className="iht-hero__accent">Four Simple Steps</span>
            </h2>
          </div>

          <div className="iht-timeline" style={{ marginTop: 48 }}>
            {HOW_IT_WORKS.map((step, i) => (
              <div className="iht-timeline__step" key={step.title}>
                <span className="iht-timeline__num">0{i + 1}</span>
                <div className="iht-timeline__rail">
                  <span className="iht-timeline__dot" />
                </div>
                <div className="iht-timeline__icon-wrap">
                  <step.icon size={22} color="#FFFFFF" strokeWidth={1.75} />
                </div>
                <h4 className="iht-timeline__title">{step.title}</h4>
                <p className="iht-timeline__copy">{step.copy}</p>
                {i < HOW_IT_WORKS.length - 1 && (
                  <ArrowRight className="iht-timeline__arrow" size={18} />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HIRING SUPPORT — answers "what if I don't have an HR team?" */}
      {/* <section className="iht-section iht-section--alt iht-section--border-y">
        <div className="iht-section__inner">
          <div className="iht-section__head">
            <div>
              <Eyebrow>No HR team? No problem</Eyebrow>
              <h2 className="iht-section__title">
                What If You Don't Have <span className="iht-hero__accent">an HR Team?</span>
              </h2>
            </div>
            <p className="iht-section__lede">
              Many AEC firms hire without one. When you need extra hands,
              IPDI assigns a dedicated hiring coordinator to handle it for you.
            </p>
          </div>

          <div className="iht-support-grid">
            {SUPPORT_SERVICES.map((s) => (
              <div className="iht-support-card" key={s.title}>
                <div className="iht-support-card__icon">
                  <s.icon size={17} color={RUST} strokeWidth={1.75} />
                </div>
                <span className="iht-support-card__title">{s.title}</span>
              </div>
            ))}
          </div>

          <div className="iht-no-hr-box">
            <div className="iht-no-hr-box__icon">
              <Users size={20} color={RUST} strokeWidth={1.75} />
            </div>
            <div>
              <h4 className="iht-no-hr-box__title">One coordinator. One point of contact.</h4>
              <p className="iht-no-hr-box__copy">
                With every eligible Workforce Development Program below, this
                support is included — no separate recruitment fee.
              </p>
            </div>
          </div>

        
        </div>
      </section> */}


 {/* BUDGET TRANSFORMATION — the core differentiator, as an infographic not a table */}
      <section className="iht-section">
        <div className="iht-section__inner">
          <div className="iht-section__head--center">
            <Eyebrow center>Our biggest differentiator</Eyebrow>
            <h2 className="iht-section__title">
              We Don't Charge a <span className="iht-hero__accent">Separate Recruitment Fee.</span>
            </h2>
            <p className="iht-section__lede" style={{ maxWidth: 560, marginTop: 8 }}>
              Your recruitment budget becomes your employee development budget.
            </p>
          </div>

          <div className="iht-budget-tag">
            <span className="iht-budget-tag__pill">
              <IndianRupee size={13} color={INK} strokeWidth={2} /> Same Hiring Budget
            </span>
            two very different outcomes
          </div>

          <div className="iht-budget-flow">
            {/* TRADITIONAL PATH */}
            <div className="iht-budget-col iht-budget-col--traditional">
              <div className="iht-budget-col__head">
                <div className="iht-budget-col__icon-badge">
                  <TrendingDown size={19} color="#B23535" strokeWidth={1.75} />
                </div>
                <div>
                  <span className="iht-budget-col__label">Traditional Hiring</span>
                  <h3 className="iht-budget-col__heading">Pay to hire. Pay again to train.</h3>
                </div>
              </div>

              <div className="iht-budget-steps">
                {TRADITIONAL_FLOW.map((step, i) => (
                  <React.Fragment key={step.label}>
                    <div className="iht-budget-step">
                      <div className="iht-budget-step__icon">
                        <step.icon size={16} color="#B23535" strokeWidth={1.75} />
                      </div>
                      <span className="iht-budget-step__label">{step.label}</span>
                    </div>
                    {i < TRADITIONAL_FLOW.length - 1 && (
                      <div className="iht-budget-connector"><span /></div>
                    )}
                  </React.Fragment>
                ))}
              </div>

              <div className="iht-budget-col__terminal">
                <Clock size={16} color="#B23535" strokeWidth={1.75} />
                <span className="iht-budget-col__terminal-text">Productive after weeks or months</span>
              </div>
            </div>

            {/* BECOMES connector (desktop) */}
            <div className="iht-budget-becomes">
              <div className="iht-budget-becomes__badge">
                <ArrowRight size={22} color="#FFFFFF" strokeWidth={2} />
              </div>
            </div>
            {/* BECOMES connector (mobile) */}
            <div className="iht-budget-becomes-mobile">
              <div className="iht-budget-becomes-mobile__badge">
                <ArrowRight size={18} color="#FFFFFF" strokeWidth={2} style={{ transform: "rotate(90deg)" }} />
              </div>
            </div>

            {/* IPDI PATH */}
            <div className="iht-budget-col iht-budget-col--ipdi">
              <div className="iht-budget-col__head">
                <div className="iht-budget-col__icon-badge">
                  <Sparkles size={19} color={RUST} strokeWidth={1.75} />
                </div>
                <div>
                  <span className="iht-budget-col__label">IPDI Workforce Model</span>
                  <h3 className="iht-budget-col__heading">One investment. Hiring support included.</h3>
                </div>
              </div>

              <div className="iht-budget-steps">
                {IPDI_FLOW.map((step, i) => (
                  <React.Fragment key={step.label}>
                    <div className="iht-budget-step">
                      <div className="iht-budget-step__icon">
                        <step.icon size={16} color={RUST} strokeWidth={1.75} />
                      </div>
                      <span className="iht-budget-step__label">{step.label}</span>
                    </div>
                    <div className="iht-budget-connector"><span /></div>
                  </React.Fragment>
                ))}
              </div>

              <div className="iht-budget-step" style={{ marginBottom: 4 }}>
                <div className="iht-budget-step__icon">
                  <TrendingUp size={16} color={RUST} strokeWidth={1.75} />
                </div>
                <span className="iht-budget-step__label">Job-Ready Employee</span>
              </div>

              <div className="iht-budget-col__terminal">
                <Rocket size={16} color={RUST} strokeWidth={1.75} />
                <span className="iht-budget-col__terminal-text">Productive from week one</span>
              </div>
            </div>
          </div>

          {/* VALUE STATEMENT */}
          <div className="iht-value-panel">
            <div className="iht-value-panel__inner">
              <span className="iht-value-panel__eyebrow">One investment. Greater value.</span>
              {/* <h3 className="iht-value-panel__title">
                Invest in your people—not recruitment fees. — <span className="iht-hero__accent">no separate recruitment fee.</span>
              </h3> */}

              <h3 className="iht-value-panel__title">
                Invest in your people <span className="iht-hero__accent">not recruitment fees.</span>
              </h3>

              <p className="iht-value-panel__copy">
                Instead of spending your hiring budget on recruitment agency fees alone,
                invest it in developing your employees. With eligible IPDI Workforce
                Development Programs, Hiring Support is included at no additional
                recruitment cost.
              </p>
              <div className="iht-value-panel__checklist">
                <div className="iht-value-check">
                  <span className="iht-value-check__icon"><CheckCircle2 size={14} color={RUST} strokeWidth={2.5} /></span>
                  Hiring Assistance
                </div>
                <div className="iht-value-check">
                  <span className="iht-value-check__icon"><CheckCircle2 size={14} color={RUST} strokeWidth={2.5} /></span>
                  Structured Training
                </div>
                <div className="iht-value-check">
                  <span className="iht-value-check__icon"><CheckCircle2 size={14} color={RUST} strokeWidth={2.5} /></span>
                  Faster Employee Productivity
                </div>
              </div>
            </div>
          </div>

          <div className="iht-hs-scroll-cta">
            <button className="iht-btn iht-btn--outline" href="#workforce-development" onClick={() => scrollToSection("workforce-development")}>
              CHOOSE YOUR PROGRAM BELOW <ArrowDown size={15} />
            </button>
          </div>
        </div>
      </section>

      {/* WORKFORCE DEVELOPMENT PROGRAMS — premium, secondary */}
      <section className="iht-section iht-section--dark" id="workforce-development">  
        <div className="iht-section__inner">
          <div className="iht-wf-head">
            <Eyebrow dark>Workforce development</Eyebrow>
            <h2 className="iht-section__title iht-section__title--light">
              Turn New Hires Into <span className="iht-hero__accent">High Performers</span>
            </h2>
            <p className="iht-wf-head__lede">
              Choose the training path for your new hire — hiring support
              comes included, at no separate recruitment fee.
            </p>
          </div>

          <div className="iht-wf-grid">
            {WORKFORCE_PROGRAMS.map((p) => (
              <div
                className={`iht-wf-card${p.featured ? " iht-wf-card--featured" : ""}${selectedPlan === p.id ? " iht-wf-card--selected" : ""}`}
                key={p.id}
              >
                {p.featured && <span className="iht-wf-card__ribbon">Most chosen</span>}

                {/* PROGRAM OVERVIEW */}
                <div className="iht-wf-card__top">
                  <span className="iht-wf-card__num">{p.num} / Program</span>
                  <span className="iht-wf-card__duration"><Clock size={11} /> {p.duration}</span>
                </div>
                <h4 className="iht-wf-card__title">{p.title}</h4>
                <p className="iht-wf-card__copy">{p.copy}</p>
                <p className="iht-wf-card__price">
                  Investment <span>₹{p.price}</span> <em>/ candidate</em>
                </p>

                <div className="iht-wf-card__divider" />

                {/* WORKFORCE DEVELOPMENT — the main product */}
                <div className="iht-wf-block iht-wf-block--dev">
                  <div className="iht-wf-block__head">
                    <div className="iht-wf-block__icon iht-wf-block__icon--dev">
                      <GraduationCap size={17} color="#FFFFFF" strokeWidth={1.75} />
                    </div>
                    <div className="iht-wf-block__head-text">
                      <span className="iht-wf-block__eyebrow iht-wf-block__eyebrow--dev">What your hire learns</span>
                      <span className="iht-wf-block__title iht-wf-block__title--dev">Workforce Development</span>
                    </div>
                  </div>
                  <p className="iht-wf-block__lede">
                    Trained on the job during the {p.duration} probation period:
                  </p>
                  <div className="iht-wf-modules">
                    {p.modules.map((m) => (
                      <div className="iht-wf-module" key={m.label}>
                        <div className="iht-wf-module__icon">
                          <m.icon size={15} color="#FFFFFF" strokeWidth={1.75} />
                        </div>
                        <span className="iht-wf-module__label">{m.label}</span>
                      </div>
                    ))}
                  </div>
                  <span className="iht-wf-outcome">
                    <TrendingUp size={13} color="#141414" strokeWidth={2.25} /> Outcome: Job-Ready Employee
                  </span>
                </div>

                {/* HIRING SUPPORT INCLUDED — the USP, framed as a bonus, not the product */}
                <div className="iht-wf-block iht-wf-block--support">
                  <div className="iht-wf-block__head iht-wf-block__head--support">
                    <div className="iht-wf-block__icon iht-wf-block__icon--support">
                      <UserCog size={16} color={RUST} strokeWidth={1.75} />
                    </div>
                    <div className="iht-wf-block__head-text">
                      <span className="iht-wf-block__eyebrow iht-wf-block__eyebrow--support">What you get, at no extra cost</span>
                      <span className="iht-wf-block__title iht-wf-block__title--support">Hiring Support Included</span>
                    </div>
                  </div>
                  <span className="iht-wf-badge">No Separate Recruitment Fee</span>
                  <div className="iht-wf-checklist">
                    {HIRING_SUPPORT_ITEMS.map((label) => (
                      <div className="iht-wf-check" key={label}>
                        <CheckCircle2 size={13} color={RUST} strokeWidth={2.25} />
                        <span>{label}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* VALUE HIGHLIGHT */}
                <div className="iht-wf-value-box">
                  <Sparkles size={15} color={RUST} strokeWidth={1.75} />
                  <p>
                    Your investment develops your employee — not recruitment
                    agencies. Hiring Support and Workforce Development, one
                    investment.
                  </p>
                </div>

                {/* <a
                  href="/recruitment-application"
                  className="iht-wf-card__select-btn"
                  style={{ textDecoration: "none" }}
                  onClick={() => setSelectedPlan(p.id)}
                >
                  GET STARTED <ArrowRight size={15} />
                </a> */}

                <a
                  href={portalLink("/recruitment-application")}
                  className="iht-wf-card__select-btn"
                  style={{ textDecoration: "none" }}
                  onClick={() => setSelectedPlan(p.id)}
                >
                  GET STARTED <ArrowRight size={15} />
                </a>

              </div>
            ))}
          </div>

          <div className="iht-wf-summary">
            <div>
              <span className="iht-wf-summary__label">Your selection</span>
              <h4 className="iht-wf-summary__title">{activePlan.title}</h4>
              <p className="iht-wf-summary__copy">
                {activePlan.modules.length} training modules ·{" "}
                {activePlan.duration} · ₹{activePlan.price} per candidate ·
                hiring support included.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}